import React from 'react'
import {BillingActivity} from '../../types/app-types'
import {
  formatAmount,
  formatBillingPeriod,
  formatDateString
} from '../../services/utils'
import NewResidentLogo from '../../assets/placemakr-new-resident.png'

interface BillingSummaryProps {
  billingActivity: BillingActivity
}

function formatSummaryAmount(amount: number) {
  if (amount < 0) {
    return `-${formatAmount(Math.abs(amount))}`
  } else {
    return formatAmount(amount)
  }
}

const BillingSummary = ({billingActivity}: BillingSummaryProps) => {
  const {
    statementPastBalance,
    statementCurrentBalance,
    dueDate,
    statementPeriodBalance,
    isFutureMoveIn
  } = billingActivity || {}
  console.log(`Billing activity => ${JSON.stringify(billingActivity)}`)
  console.log(`statementPastBalance=>${statementPastBalance}`)
  return (
    <div>
      {!isFutureMoveIn &&
      statementPastBalance &&
      statementCurrentBalance &&
      statementPeriodBalance ? (
        <table className="text-sm w-full">
          <thead>
            <tr>
              <td colSpan={2} className="uppercase text-primary font-bold">
                Summary:
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-0 w-48">
                {formatBillingPeriod(dueDate)} Balance:
              </td>
              <td className="text-right">
                {formatSummaryAmount(statementPeriodBalance)}
              </td>
            </tr>
            <tr className="border-solid">
              <td className="p-0 w-48">Previous Month's Balance:</td>
              <td className="text-right">
                {formatSummaryAmount(statementPastBalance)}
              </td>
            </tr>
            <tr className="border-solid border-b-2">
              <td className="p-0 w-48">Total Balance Due:</td>
              <td className="text-right">
                {formatSummaryAmount(statementCurrentBalance)}
              </td>
            </tr>
            <tr>
              <td className="p-0 w-48">Due Date:</td>
              <td className="text-right">{formatDateString(dueDate)}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div className="flex flex-row">
          <div className="my-auto">
            <div>
              <img src={NewResidentLogo} className="h-18 w-18" />
            </div>
          </div>
          <div className="justify-left px-4">
            The current balance reflects all charges due prior to your move-in
            date of:
            <br />
            <span className="font-bold">{formatDateString(dueDate)}</span>.
          </div>
        </div>
      )}
    </div>
  )
}

export default BillingSummary
